const isDevice = require('./module/_ua.js');
const onYouTubeIframeAPIReady = require('./module/_yt_api.js')
const adjustMovieSize = require('./module/_ajust_movie_size.js')


//mousewheeleventのクロスブラウザ対策
if('onwheel' in document){
	var mousewheelevent = 'wheel';
}else if('onmousewheel' in document){
	var mousewheelevent = 'mousewheel';
}else{
	var mousewheelevent = 'DOMMouseScroll';
}

const $window = $(window);
const $body = $('body');
const $wrap = $('.wrap');

//mausewheeleventのロック状態
let isMouseWheelLock = false;

//sectionの並び順
const section_ary = [
	'mainvisual',
	'debug',
	'localize',
	'illust',
	'promo',
	'print'
];

let VIDEO_ID = [
	'',
	'LQGw-Bq7gbI',
	'Mva8wG_PUKU',
	'wE3_LNl8fD4',
	'jvcTQWZXIXQ',
	'6WeMeWu_x3A'
];

const VIDEO_RATE = [
	0,
	1.2,
	1,
	1.2,
	1,
	1
]

const section_ary_len = section_ary.length;


function FnTop(){
	this.init();
}

FnTop.prototype = {
	init: function(){
		const self = this;

		// VIDEO_ID = ($('html').data('ytid').split(","));
		//console.log(VIDEO_ID);

		$window.on(mousewheelevent,function(e){
			if($('body')[0].getAttribute('data-category') == 'top'){
				e.preventDefault();
				self.onEvent(e);
				$(document).on('click', '.btn--pagetop', function(){
					$wrap[0].setAttribute('data-current', 'mainvisual');
					$body[0].setAttribute('data-current', 'mainvisual');
					$('.section--top--print').removeClass('is--current');
					$('.section--top--print .section--top__main').removeClass('is--current');
					$('.section--top--mainvisual').addClass('is--current');
					$('.footer').removeClass('is--current');
					$wrap.removeAttr('style');
					setTimeout(function(){
						$('.section--top--print' + ' .section--top__bg').html('<div id="bgMovie--print">');
					}, 500);
				})
			}
		});
	},
	onEvent: function(e){

		const hash = this.getHash();
		const delta = this.getDelta(e);

		if (isMouseWheelLock === false) {
			//mousewheelevent時の動作
			if(delta < 0 && hash !== section_ary[section_ary_len-1]){
				var next = section_ary.indexOf(hash)+1;
				$wrap[0].setAttribute('data-current', section_ary[next]);
				$body[0].setAttribute('data-current', section_ary[next]);
				$('.section--top--' + hash).removeClass('is--current');
				$('.section--top--' + hash + ' .section--top__main').removeClass('is--current');
				$('.section--top--' + section_ary[next]).addClass('is--current');
				onYouTubeIframeAPIReady(VIDEO_ID[next], section_ary[next], VIDEO_RATE[next]);
				adjustMovieSize(section_ary[next]);
				setTimeout(function(){
					$('.section--top--' + hash + ' .section--top__bg').html('<div id="bgMovie--' + hash + '">');
				}, 500);
			}else if(delta < 0 && hash == 'print'){
				$wrap.css('transform', 'translateY(-580%)');
				$('.footer').addClass('is--current');
			}else if(delta > 0 && $('.footer').hasClass('is--current')){
				$wrap.removeAttr('style');
				$('.footer').removeClass('is--current');
			}else if(delta > 0 && !(hash == '' || hash == section_ary[0])){
				var prev = section_ary.indexOf(hash)-1;
				$wrap[0].setAttribute('data-current', section_ary[prev]);
				$body[0].setAttribute('data-current', section_ary[prev]);
				$('.section--top--' + hash).removeClass('is--current');
				$('.section--top--' + hash + ' .section--top__main').removeClass('is--current');
				$('.section--top--' + section_ary[prev]).addClass('is--current');
				onYouTubeIframeAPIReady(VIDEO_ID[prev], section_ary[prev], VIDEO_RATE[prev]);
				adjustMovieSize(section_ary[prev]);
				setTimeout(function(){
					$('.section--top--' + hash + ' .section--top__bg').html('<div id="bgMovie--' + hash + '">');
				}, 500);
			}

			//mouseWheelをロック
			isMouseWheelLock = true;

			//mouseWheelのロックを解除
			setTimeout(function() {
				isMouseWheelLock = false;
			}, 1500);
		}
	},
	getHash: function(){
		//現在位置を取得
		let hash = $wrap[0].getAttribute('data-current');
		return hash;
	},
	getDelta: function(e){
		//mausuwheelの方向を取得
		if(e.originalEvent.deltaY){
			var delta = -(e.originalEvent.deltaY);
		}else if(e.originalEvent.wheelDelta){
			var delta = e.originalEvent.wheelDelta;
		}else{
			var delta = -(e.origtruevent.detail);
		}
		return delta;
	},
	news: function(){
	}
}

module.exports = FnTop;



// WEBPACK FOOTER //
// ./es2015/_top.js